import { companyNow, money } from '../../utils/format'
import { docNo } from '../../utils/docNumbers'

// Helpers shared by the Sales pages.

export const num = (v) => {
  const n = Number(String(v ?? '').replace(/,/g, ''))
  return Number.isFinite(n) ? n : 0
}

export { money }

export const statusOf = (row) => String(row?.status || '').trim().toLowerCase()

/** A till transaction's own number: SALE-0045, or RF-0046 for a refund (one series). */
export const saleNo = (row) => docNo(row?.original_sale_id || statusOf(row) === 'refunded' ? 'refund' : 'sale', row?.sale_no)

const pad = (n) => String(n).padStart(2, '0')
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`

export const PERIODS = [
  { id: 'today', label: 'Today' },
  { id: 'yesterday', label: 'Yesterday' },
  { id: 'week', label: 'Last 7 days' },
  { id: 'month', label: 'This month' },
  { id: 'last-month', label: 'Last month' },
  { id: 'custom', label: 'Choose dates…' },
]

/** A preset period as [start, end] days on the company's clock. This month
    runs to its last day, so anything dated later in it still shows. */
export function periodRange(id) {
  const today = companyNow()
  const shift = (days) => { const d = new Date(today); d.setDate(d.getDate() + days); return d }
  if (id === 'yesterday') return [ymd(shift(-1)), ymd(shift(-1))]
  if (id === 'week') return [ymd(shift(-6)), ymd(today)]
  if (id === 'month') return [ymd(new Date(today.getFullYear(), today.getMonth(), 1)), ymd(new Date(today.getFullYear(), today.getMonth() + 1, 0))]
  if (id === 'last-month') return [ymd(new Date(today.getFullYear(), today.getMonth() - 1, 1)), ymd(new Date(today.getFullYear(), today.getMonth(), 0))]
  return [ymd(today), ymd(today)]
}

/** The preset matching [start, end], or 'custom'. */
export const periodFor = (start, end) => PERIODS.find((p) => p.id !== 'custom' && periodRange(p.id).join() === `${start},${end}`)?.id || 'custom'

/** Where to continue an unfinished refund from the drafts scan. */
export const resumeRefundPath = (row) => {
  const rid = row.refund_sale_id || row.sale_id
  return row.original_sale_id ? `/sales/refund/${row.original_sale_id}?refund=${rid}` : null
}
